module.exports = __webpack_public_path__ + "img/bg2.2ae5a8e7.jpg";